export default __webpack_public_path__ + "static/media/orbit-icon.15d01eba.svg";